// Toggle accordion 

jQuery('.btn-read-more').on('click', function (e) {
    e.preventDefault();
    let target = $(this).attr('href');
    jQuery(this).attr('aria-expanded', 'true');
    jQuery(this).closest('.accordion-item').addClass('accordion-open').find('.btn-read-less').attr('aria-expanded', 'true');
    jQuery(target).attr('tabindex', '-1').trigger('focus');
});

jQuery('.btn-read-less').on('click', function (e) {
    e.preventDefault();
    let target = $(this).attr('href');
    jQuery(this).attr('aria-expanded', 'false');
    jQuery(this).closest('.accordion-item').removeClass('accordion-open').find('.btn-read-more').attr('aria-expanded', 'false');
    jQuery('a[href="'+target+'"]').trigger('focus');
});
